import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconArrowRight = (props, ref) => _jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { d: "M12.946 5.053a1 1 0 1 0-1.414 1.414L16.064 11H6a1 1 0 1 0 0 2h10.064l-4.532 4.532a1 1 0 1 0 1.414 1.414l5.532-5.532a2 2 0 0 0 0-2.828z" }) });
const ForwardRef = forwardRef(SvgIconArrowRight);
export default ForwardRef;
